module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/call/completed-09e5ab3bc61c986b6229cca5092f5887.svg";